<template>
  <section>
    <h1 class="h2 mb-3">Financials</h1>
    <data-table :dataRows="invoicesWithTotal" :dataColumns="columns" :options="options">
      <tableTextTemplate slot-scope="{ row }" slot="expandedHeader" :text="row.id" :row="row" :options="{ expandMobile: true, showPaid: true }" />
      <div slot-scope="{ row }" slot="expandedRow">
        <ul class="list-unstyled mb-0 pt-2">
          <li>
            <strong>Amount: </strong>
            <tableTextTemplate :text="'$' + getDisplayTotal(row)" :row="row" :options="{ inline: true }" />
          </li>
          <li>
            <strong>Date: </strong>
            <tableTextTemplate :text="new Date(row.created_at.replace(/-/g, '/')).toLocaleString('en-AU')" :row="row" :options="{ inline: true }" />
          </li>
          <li>
            <strong>Purchase: </strong>
            <tableTextTemplate :text="row.type.charAt(0).toUpperCase() + row.type.slice(1)" :row="row" :options="{ inline: true }" />
          </li>
          <li class="pt-3 d-block d-sm-inline-block">
            <tableDownloadTemplate :row="row" />
          </li>
        </ul>
      </div>
    </data-table>
  </section>
</template>

<script>
import axios from 'axios'
import dataTable from '@/components/DataTable'
import tableTextTemplate from '@/components/DataTableFields/Text'
import tableDownloadTemplate from '@/components/DataTableFields/Download'

export default {
  name: 'MembersProfileFinancials',
  props: ['memberID'],
  components: {
    'data-table': dataTable,
    tableTextTemplate,
    tableDownloadTemplate
  },
  data() {
    return {
      isAdmin: this.$isAdmin,
      columns: [
        {
          label: 'Invoice No.',
          field: 'id',
          filterable: false,
          headerClass: 'd-none d-lg-table-cell',
          visible: true,
          component: ({
            props: ['row'],
            components: { tableTextTemplate },
            template: `<tableTextTemplate :text="row.invoice_number" :row="row" :options="{}" />`
          }),
          representedAs: 'id'
        },
        {
          label: 'Amount',
          field: 'total',
          filterable: false,
          headerClass: 'd-none d-lg-table-cell',
          visible: true,
          component: ({
            props: ['row'],
            components: { tableTextTemplate },
            template: `<tableTextTemplate :text="'$' + row.displayTotal" :row="row" :options="{ showPaid: true }" />`
          }),
          representedAs: 'total'
        },
        {
          label: 'Date',
          field: 'paid_date',
          sortable: true,
          filterable: false,
          headerClass: 'd-none d-lg-table-cell',
          visible: true,
          component: ({
            props: ['row'],
            components: { tableTextTemplate },
            template: `<tableTextTemplate :text="row.paid_date ? new Date(row.paid_date).toLocaleString('en-AU').substring(0, 10) : new Date(row.created_at.replace(/-/g, '/')).toLocaleString('en-AU').substring(0, 10)" :row="row" :options="{}" />`
          }),
          representedAs: `new Date(row.paid_date).toLocaleString('en-AU').substring(0, 10)`
        },
        {
          label: 'Purchase',
          field: 'type',
          filterable: false,
          headerClass: 'd-none d-lg-table-cell',
          visible: true,
          component: ({
            props: ['row'],
            components: { tableTextTemplate },
            template: `<tableTextTemplate :text="row.type.charAt(0).toUpperCase() + row.type.slice(1)" :row="row" :options="{}" />`
          }),
          representedAs: 'type'
        },
        {
          label: 'Download',
          align: 'left',
          sortable: false,
          filterable: false,
          headerClass: 'column-lg-small d-none d-lg-table-cell',
          visible: true,
          component: ({
            props: ['row'],
            components: { tableDownloadTemplate },
            template: `<tableDownloadTemplate :row="row" />`
          })
        }
      ],
      options: {
        filter: {
          status: [
            { name: 'All', value: 'all' },
            { name: 'Paid', value: 'paid' },
            { name: 'Pending', value: 'pending' }
          ]
        },
        activeFilter: {
          status: 'all'
        },
        search: true,
        loaded: false
      }
    }
  },
  computed: {
    invoicesWithTotal() {
      return this.$store.state.invoices.map(row => ({
        ...row,
        displayTotal: this.getDisplayTotal(row)
      }))
    }
  },
  methods: {
    getDisplayTotal(row) {
      const fee = parseFloat(row.processing_fee || 0)
      if (Number.isFinite(fee) && fee > 0) {
        return row.total_with_fee
      }
      return row.total
    }
  },
  mounted() {
    axios.get(`${this.$api}/invoices/${this.memberID}`).then((response) => {
      this.options.loaded = true
      if (response.data.status === 'success') {
        response.data.data.map((item) => {
          if (item.type === 'rookie-nomination') {
            const season = `${item.items[0].productable.start_year}/${item.items[0].productable.start_year + 1}`
            item.type = `${item.type.charAt(0).toUpperCase()}${item.type.slice(1)}-${season}`
          }
          return item
        })
        this.$store.commit('updateInvoices', response.data.data)
      }
    }).catch((error) => {
      // eslint-disable-next-line
      console.log(error)
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Members/Tabs/Financials.vue